// Sincronizado com StatusTransferenciaEstoqueEnum do backend ATS.Hub.API.Suprimentos
export enum StatusTransferenciaEnum {
  Pendente = 1,
  Falha = 2,
  EmTransito = 3,
  Cancelado = 4,
  Concluido = 5,
}
